import { useEffect } from "react";
import { useDispatch, useSelector } from "../../hooks";
import { getBoosts } from "../../redux/boosts/get-boosts.handler";
import { Loader } from "../../components/Loader/Loader";
import { ErrorSnackbar } from "../../components/ErrorSnackbar/ErrorSnackbar";
import styles from "./BoostsPage.module.scss";
import { ContentWrapper } from "../../components/ContentWrapper/ContentWrapper";
import { PageTitleBlock } from "../../components/PageTitleBlock/PageTitleBlock";
import { CardWrapper } from "../../components/CardWrapper/CardWrapper";
import { BoostCard } from "../../components/BoostCard/BoostCard";

export const BoostsPage = () => {
    const dispatch = useDispatch();
    const { userBoosts, lib, loading, error } = useSelector(store => store.boosts);

    useEffect(() => {
        dispatch(getBoosts());
    }, [dispatch]);

    return (
        <>
            <ContentWrapper>
                <div className={styles.wrapper}>
                    <PageTitleBlock pageTitle={"Усиления"} />

                    <CardWrapper>
                        { lib?.map(libBoost => {
                            const userBoost = userBoosts.find(boost => boost.type === libBoost.id);
                            const userCount = userBoost ? userBoost.count : 0;

                            return <BoostCard
                                key={`boost${libBoost.id}`}
                                { ...libBoost }
                                userCount={ userCount }
                            />
                        }) }
                    </CardWrapper>
                </div>
            </ContentWrapper>

            { loading && <Loader /> }
            { error.length > 0 && <ErrorSnackbar errorMessage={ error } /> }
        </>
    );
}